import { createGlobalStyle } from "styled-components";
import { aaaCustomColorsDark } from "./aaaCustomColorsDark";

export const aaaGlobalCSSDark = createGlobalStyle`
    body {
        font-family: Inter;
        background-color: ${aaaCustomColorsDark.darkPrimary};
    }

    h1, .h1 {
        font-family: Inter;
        color: ${aaaCustomColorsDark.darkForeground};
        font-size: 80px;
        font-weight: 700;
        line-height: 97px;
    } 

    h2, .h2 {
        font-family: Inter;
        color: ${aaaCustomColorsDark.darkForeground};
        font-size: 50px;
        font-weight: 700;
        line-height: 49px;
    }

    h3, .h3 {
        font-family: Inter;
        color: ${aaaCustomColorsDark.darkForeground};
        font-size: 24px;
        font-weight: 700;
        line-height: 29px;
    }

    p, .body1 {
        font-family: Inter;
        color: ${aaaCustomColorsDark.darkForeground};
        font-size: 16px;
        font-weight: 400;
        line-height: 27px;
    }

    .body1semibold {
        font-family: Inter;
        color: ${aaaCustomColorsDark.darkForeground};
        font-size: 16px;
        font-weight: 600;
        line-height: 27px;
    }

    .body2 {
        font-family: Inter;
        color: ${aaaCustomColorsDark.darkForeground};
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
    }

    .body2semibold {
        font-family: Inter;
        color: ${aaaCustomColorsDark.darkForeground};
        font-size: 14px;
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
    }

    .caption {
        font-family: Inter;
        color: ${aaaCustomColorsDark.darkForeground};
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
    }

    .applicationDateChip {
        color: ${aaaCustomColorsDark.darkForeground}; //TODO: If confirmed, put in shade of jobCategory
        background-color: ${aaaCustomColorsDark.darkTertiary};
        border:  "none";
    }

    .kanbanColumnHeader {
        background-color: ${aaaCustomColorsDark.darkPrimary};
    }

    .hrBotMultipleButton {
        background-color: ${aaaCustomColorsDark.primary};
        border: none;
        border-radius: 4px;
        color: ${aaaCustomColorsDark.darkForeground}
    }

    .timePicker {
        background-color: ${aaaCustomColorsDark.darkSecondary};
    }

    .historyLine {
        border-bottom: 1px solid ${aaaCustomColorsDark.darkForeground}
    }

    .customNumberField {
        background-color: ${aaaCustomColorsDark.darkTertiary};
        border-bottom: none;
        border-top: none;
        color: ${aaaCustomColorsDark.darkForeground}
    }

    .sideBar {
        border-right: 1px solid ${aaaCustomColorsDark.borderColor};
        background-color: ${aaaCustomColorsDark.darkPrimary};
    }

    .noteHeader {
        border-bottom: 1px solid ${aaaCustomColorsDark.darkTertiary};
    }

    .disabled {
        opacity: 0.15;
    }

    .loginSite {
        background-color: ${aaaCustomColorsDark.darkPrimary}; 
    }

    .notification {
        border-bottom: 1px solid ${aaaCustomColorsDark.darkTertiary};
    }

    .commentsContainer {
        background-color: ${aaaCustomColorsDark.darkTertiary};
    }

    .comment {
        border-bottom: 1px solid ${aaaCustomColorsDark.white};
    }

    .codeExampleFile {
        background-color: ${aaaCustomColorsDark.darkTertiary};
    }
`;
